import HttpRequest from '@/libs/axios'

import config from '@/config'

const baseUrl = process.env.NODE_ENV === 'development' ? config.apiDomainConfig.dev.baseUrl : config.apiDomainConfig.pro.baseUrl

const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js